module.exports = __webpack_public_path__ + "live_detail_pop-e84b1852.png";